
import { Vue, Component } from 'vue-property-decorator';
import CustomAlert from '~/components/Alerts/Alert.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';

@Component({ components: { CustomAlert, CustomButton } })
export default class PaymentAmountWarning extends Vue {
  expanded = false;
}
